"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var React = require("react");
var __1 = require("../../");
var AccountIcon_1 = require("../Assets/AccountIcon");
var AgentBookingIcon_1 = require("../Assets/AgentBookingIcon");
var AlertIcon_1 = require("../Assets/AlertIcon");
var AlertOutlineIcon_1 = require("../Assets/AlertOutlineIcon");
var AlertTriangleIcon_1 = require("../Assets/AlertTriangleIcon");
var ApplicationCompleteIcon_1 = require("../Assets/ApplicationCompleteIcon");
var ApplicationIcon_1 = require("../Assets/ApplicationIcon");
var ArrowDownIcon_1 = require("../Assets/ArrowDownIcon");
var ArrowDownrightIcon_1 = require("../Assets/ArrowDownrightIcon");
var ArrowLeftIcon_1 = require("../Assets/ArrowLeftIcon");
var ArrowRightIcon_1 = require("../Assets/ArrowRightIcon");
var ArrowUpIcon_1 = require("../Assets/ArrowUpIcon");
var AsteriskIcon_1 = require("../Assets/AsteriskIcon");
var AttendeesIcon_1 = require("../Assets/AttendeesIcon");
var BarcodeIcon_1 = require("../Assets/BarcodeIcon");
var BookingIcon_1 = require("../Assets/BookingIcon");
var BuildingIcon_1 = require("../Assets/BuildingIcon");
var BulletIcon_1 = require("../Assets/BulletIcon");
var CalendarIcon_1 = require("../Assets/CalendarIcon");
var CameraIcon_1 = require("../Assets/CameraIcon");
var CancelledIcon_1 = require("../Assets/CancelledIcon");
var CaretDownIcon_1 = require("../Assets/CaretDownIcon");
var CaretLeftIcon_1 = require("../Assets/CaretLeftIcon");
var CaretRightIcon_1 = require("../Assets/CaretRightIcon");
var CaretUpIcon_1 = require("../Assets/CaretUpIcon");
var ChartGanttIcon_1 = require("../Assets/ChartGanttIcon");
var ChartReportIcon_1 = require("../Assets/ChartReportIcon");
var CheckboxIcon_1 = require("../Assets/CheckboxIcon");
var CheckboxUnselectedIcon_1 = require("../Assets/CheckboxUnselectedIcon");
var CheckInIcon_1 = require("../Assets/CheckInIcon");
var CheckOutIcon_1 = require("../Assets/CheckOutIcon");
var ChevronDownIcon_1 = require("../Assets/ChevronDownIcon");
var ChevronDownSmallIcon_1 = require("../Assets/ChevronDownSmallIcon");
var ChevronLeftIcon_1 = require("../Assets/ChevronLeftIcon");
var ChevronLeftSmallIcon_1 = require("../Assets/ChevronLeftSmallIcon");
var ChevronRightIcon_1 = require("../Assets/ChevronRightIcon");
var ChevronRightSmallIcon_1 = require("../Assets/ChevronRightSmallIcon");
var ChevronRightThinIcon_1 = require("../Assets/ChevronRightThinIcon");
var ChevronUpIcon_1 = require("../Assets/ChevronUpIcon");
var ChevronUpSmallIcon_1 = require("../Assets/ChevronUpSmallIcon");
var ChevronUpThinIcon_1 = require("../Assets/ChevronUpThinIcon");
var ClearFiltersIcon_1 = require("../Assets/ClearFiltersIcon");
var ClockIcon_1 = require("../Assets/ClockIcon");
var CloseCircleIcon_1 = require("../Assets/CloseCircleIcon");
var CloseThickIcon_1 = require("../Assets/CloseThickIcon");
var CloseThinIcon_1 = require("../Assets/CloseThinIcon");
var CogIcon_1 = require("../Assets/CogIcon");
var ColumnIcon_1 = require("../Assets/ColumnIcon");
var ConnectIcon_1 = require("../Assets/ConnectIcon");
var DesignerIcon_1 = require("../Assets/DesignerIcon");
var DragIcon_1 = require("../Assets/DragIcon");
var EditIcon_1 = require("../Assets/EditIcon");
var EllipsesHorizontalIcon_1 = require("../Assets/EllipsesHorizontalIcon");
var EllipsesVerticalIcon_1 = require("../Assets/EllipsesVerticalIcon");
var ExportIcon_1 = require("../Assets/ExportIcon");
var FieldTypeBooleanIcon_1 = require("../Assets/FieldTypeBooleanIcon");
var FieldTypeDateIcon_1 = require("../Assets/FieldTypeDateIcon");
var FieldTypeIntIcon_1 = require("../Assets/FieldTypeIntIcon");
var FieldTypeKeyIcon_1 = require("../Assets/FieldTypeKeyIcon");
var FieldTypeStringIcon_1 = require("../Assets/FieldTypeStringIcon");
var FileIcon_1 = require("../Assets/FileIcon");
var FilterActiveIcon_1 = require("../Assets/FilterActiveIcon");
var FiltersIcon_1 = require("../Assets/FiltersIcon");
var FirstIcon_1 = require("../Assets/FirstIcon");
var FlagIcon_1 = require("../Assets/FlagIcon");
var FolderIcon_1 = require("../Assets/FolderIcon");
var FolderOpenIcon_1 = require("../Assets/FolderOpenIcon");
var FolderOutlineIcon_1 = require("../Assets/FolderOutlineIcon");
var FolderSharedIcon_1 = require("../Assets/FolderSharedIcon");
var FolderStarredIcon_1 = require("../Assets/FolderStarredIcon");
var FoodIcon_1 = require("../Assets/FoodIcon");
var FunctionIcon_1 = require("../Assets/FunctionIcon");
var GroupsIcon_1 = require("../Assets/GroupsIcon");
var HeadsetIcon_1 = require("../Assets/HeadsetIcon");
var HeartIcon_1 = require("../Assets/HeartIcon");
var HelpIcon_1 = require("../Assets/HelpIcon");
var HideIcon_1 = require("../Assets/HideIcon");
var HomeIcon_1 = require("../Assets/HomeIcon");
var ImagePlaceholderIcon_1 = require("../Assets/ImagePlaceholderIcon");
var ImportIcon_1 = require("../Assets/ImportIcon");
var InfoIcon_1 = require("../Assets/InfoIcon");
var InspectionIcon_1 = require("../Assets/InspectionIcon");
var InteractionIcon_1 = require("../Assets/InteractionIcon");
var InvoicingIcon_1 = require("../Assets/InvoicingIcon");
var KeyIcon_1 = require("../Assets/KeyIcon");
var LastIcon_1 = require("../Assets/LastIcon");
var LinkIcon_1 = require("../Assets/LinkIcon");
var ListIcon_1 = require("../Assets/ListIcon");
var LockIcon_1 = require("../Assets/LockIcon");
var MailIcon_1 = require("../Assets/MailIcon");
var MapMarkerIcon_1 = require("../Assets/MapMarkerIcon");
var ModuleAdminIcon_1 = require("../Assets/ModuleAdminIcon");
var ModuleCampusLifeIcon_1 = require("../Assets/ModuleCampusLifeIcon");
var ModuleConductIcon_1 = require("../Assets/ModuleConductIcon");
var ModuleConferenceIcon_1 = require("../Assets/ModuleConferenceIcon");
var ModuleCustomIcon_1 = require("../Assets/ModuleCustomIcon");
var ModuleDashboardIcon_1 = require("../Assets/ModuleDashboardIcon");
var ModuleEntriesIcon_1 = require("../Assets/ModuleEntriesIcon");
var ModuleFrontDeskIcon_1 = require("../Assets/ModuleFrontDeskIcon");
var ModuleKeysIcon_1 = require("../Assets/ModuleKeysIcon");
var ModuleMarketplaceIcon_1 = require("../Assets/ModuleMarketplaceIcon");
var ModulePortalIcon_1 = require("../Assets/ModulePortalIcon");
var ModuleReportsIcon_1 = require("../Assets/ModuleReportsIcon");
var ModuleRoomInspectionsIcon_1 = require("../Assets/ModuleRoomInspectionsIcon");
var ModuleRoomMatchIcon_1 = require("../Assets/ModuleRoomMatchIcon");
var ModuleRoomsIcon_1 = require("../Assets/ModuleRoomsIcon");
var ModuleTrustAccountIcon_1 = require("../Assets/ModuleTrustAccountIcon");
var MouseHandDragIcon_1 = require("../Assets/MouseHandDragIcon");
var MouseHandIcon_1 = require("../Assets/MouseHandIcon");
var MousePointerIcon_1 = require("../Assets/MousePointerIcon");
var NavIcon_1 = require("../Assets/NavIcon");
var NoteAddIcon_1 = require("../Assets/NoteAddIcon");
var NoteIcon_1 = require("../Assets/NoteIcon");
var OpenLinkIcon_1 = require("../Assets/OpenLinkIcon");
var PageIcon_1 = require("../Assets/PageIcon");
var PageLandscapeIcon_1 = require("../Assets/PageLandscapeIcon");
var PagePortraitIcon_1 = require("../Assets/PagePortraitIcon");
var PaperClip_1 = require("../Assets/PaperClip");
var ParameterActiveIcon_1 = require("../Assets/ParameterActiveIcon");
var ParameterIcon_1 = require("../Assets/ParameterIcon");
var ParcelIcon_1 = require("../Assets/ParcelIcon");
var PawIcon_1 = require("../Assets/PawIcon");
var PhoneIcon_1 = require("../Assets/PhoneIcon");
var PictureIcon_1 = require("../Assets/PictureIcon");
var PlusIcon_1 = require("../Assets/PlusIcon");
var PortalIcon_1 = require("../Assets/PortalIcon");
var PreviewIcon_1 = require("../Assets/PreviewIcon");
var PrintIcon_1 = require("../Assets/PrintIcon");
var RefreshIcon_1 = require("../Assets/RefreshIcon");
var ReportIcon_1 = require("../Assets/ReportIcon");
var RepositionIcon_1 = require("../Assets/RepositionIcon");
var ResourcesIcon_1 = require("../Assets/ResourcesIcon");
var SaveIcon_1 = require("../Assets/SaveIcon");
var SearchIcon_1 = require("../Assets/SearchIcon");
var SearchStopIcon_1 = require("../Assets/SearchStopIcon");
var ShareIcon_1 = require("../Assets/ShareIcon");
var ShieldNegativeIcon_1 = require("../Assets/ShieldNegativeIcon");
var ShieldPositiveIcon_1 = require("../Assets/ShieldPositiveIcon");
var SortIcon_1 = require("../Assets/SortIcon");
var SourceIcon_1 = require("../Assets/SourceIcon");
var SrIconFullIcon_1 = require("../Assets/SrIconFullIcon");
var SrIconSimpleIcon_1 = require("../Assets/SrIconSimpleIcon");
var StarIcon_1 = require("../Assets/StarIcon");
var StarOutlineIcon_1 = require("../Assets/StarOutlineIcon");
var SubReportIcon_1 = require("../Assets/SubReportIcon");
var TasksIcon_1 = require("../Assets/TasksIcon");
var TemporarySpaceIcon_1 = require("../Assets/TemporarySpaceIcon");
var TickCircleIcon_1 = require("../Assets/TickCircleIcon");
var TickIcon_1 = require("../Assets/TickIcon");
var TickRoundedIcon_1 = require("../Assets/TickRoundedIcon");
var ToolIcon_1 = require("../Assets/ToolIcon");
var TrashIcon_1 = require("../Assets/TrashIcon");
var UserIcon_1 = require("../Assets/UserIcon");
var UsersIcon_1 = require("../Assets/UsersIcon");
var VariableIcon_1 = require("../Assets/VariableIcon");
var ViewIcon_1 = require("../Assets/ViewIcon");
var ZoomIcon_1 = require("../Assets/ZoomIcon");
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.renderIconSet(this.props));
    };
    Icon.prototype.renderIconSet = function (icon) {
        switch (icon.Icon) {
            case __1.Icons.Account:
                return React.createElement(AccountIcon_1.AccountIcon, __assign({}, icon));
            case __1.Icons.AgentBooking:
                return React.createElement(AgentBookingIcon_1.AgentBookingIcon, __assign({}, icon));
            case __1.Icons.Alert:
                return React.createElement(AlertIcon_1.AlertIcon, __assign({}, icon));
            case __1.Icons.AlertOutline:
                return React.createElement(AlertOutlineIcon_1.AlertOutlineIcon, __assign({}, icon));
            case __1.Icons.AlertTriangle:
                return React.createElement(AlertTriangleIcon_1.AlertTriangleIcon, __assign({}, icon));
            case __1.Icons.Application:
                return React.createElement(ApplicationIcon_1.ApplicationIcon, __assign({}, icon));
            case __1.Icons.ApplicationComplete:
                return React.createElement(ApplicationCompleteIcon_1.ApplicationCompleteIcon, __assign({}, icon));
            case __1.Icons.ArrowDown:
                return React.createElement(ArrowDownIcon_1.ArrowDownIcon, __assign({}, icon));
            case __1.Icons.ArrowDownright:
                return React.createElement(ArrowDownrightIcon_1.ArrowDownRightIcon, __assign({}, icon));
            case __1.Icons.ArrowLeft:
                return React.createElement(ArrowLeftIcon_1.ArrowLeftIcon, __assign({}, icon));
            case __1.Icons.ArrowRight:
                return React.createElement(ArrowRightIcon_1.ArrowRightIcon, __assign({}, icon));
            case __1.Icons.ArrowUp:
                return React.createElement(ArrowUpIcon_1.ArrowUpIcon, __assign({}, icon));
            case __1.Icons.Asterisk:
                return React.createElement(AsteriskIcon_1.AsteriskIcon, __assign({}, icon));
            case __1.Icons.Attendees:
                return React.createElement(AttendeesIcon_1.AttendeesIcon, __assign({}, icon));
            case __1.Icons.Barcode:
                return React.createElement(BarcodeIcon_1.BarcodeIcon, __assign({}, icon));
            case __1.Icons.Booking:
                return React.createElement(BookingIcon_1.BookingIcon, __assign({}, icon));
            case __1.Icons.Building:
                return React.createElement(BuildingIcon_1.BuildingIcon, __assign({}, icon));
            case __1.Icons.Bullet:
                return React.createElement(BulletIcon_1.BulletIcon, __assign({}, icon));
            case __1.Icons.Calendar:
                return React.createElement(CalendarIcon_1.CalendarIcon, __assign({}, icon));
            case __1.Icons.Camera:
                return React.createElement(CameraIcon_1.CameraIcon, __assign({}, icon));
            case __1.Icons.Cancelled:
                return React.createElement(CancelledIcon_1.CancelledIcon, __assign({}, icon));
            case __1.Icons.CaretDown:
                return React.createElement(CaretDownIcon_1.CaretDownIcon, __assign({}, icon));
            case __1.Icons.CaretLeft:
                return React.createElement(CaretLeftIcon_1.CaretLeftIcon, __assign({}, icon));
            case __1.Icons.CaretRight:
                return React.createElement(CaretRightIcon_1.CaretRightIcon, __assign({}, icon));
            case __1.Icons.CaretUp:
                return React.createElement(CaretUpIcon_1.CaretUpIcon, __assign({}, icon));
            case __1.Icons.ChartGantt:
                return React.createElement(ChartGanttIcon_1.ChartGanttIcon, __assign({}, icon));
            case __1.Icons.ChartReport:
                return React.createElement(ChartReportIcon_1.ChartReportIcon, __assign({}, icon));
            case __1.Icons.Checkbox:
                return React.createElement(CheckboxIcon_1.CheckboxIcon, __assign({}, icon));
            case __1.Icons.CheckboxUnselected:
                return React.createElement(CheckboxUnselectedIcon_1.CheckboxUnselectedIcon, __assign({}, icon));
            case __1.Icons.CheckIn:
                return React.createElement(CheckInIcon_1.CheckInIcon, __assign({}, icon));
            case __1.Icons.CheckOut:
                return React.createElement(CheckOutIcon_1.CheckOutIcon, __assign({}, icon));
            case __1.Icons.ChevronDown:
                return React.createElement(ChevronDownIcon_1.ChevronDownIcon, __assign({}, icon));
            case __1.Icons.ChevronDownSmall:
                return React.createElement(ChevronDownSmallIcon_1.ChevronDownSmallIcon, __assign({}, icon));
            case __1.Icons.ChevronLeft:
                return React.createElement(ChevronLeftIcon_1.ChevronLeftIcon, __assign({}, icon));
            case __1.Icons.ChevronLeftSmall:
                return React.createElement(ChevronLeftSmallIcon_1.ChevronLeftSmallIcon, __assign({}, icon));
            case __1.Icons.ChevronRight:
                return React.createElement(ChevronRightIcon_1.ChevronRightIcon, __assign({}, icon));
            case __1.Icons.ChevronRightSmall:
                return React.createElement(ChevronRightSmallIcon_1.ChevronRightSmallIcon, __assign({}, icon));
            case __1.Icons.ChevronRightThin:
                return React.createElement(ChevronRightThinIcon_1.ChevronRightThinIcon, __assign({}, icon));
            case __1.Icons.ChevronUp:
                return React.createElement(ChevronUpIcon_1.ChevronUpIcon, __assign({}, icon));
            case __1.Icons.ChevronUpSmall:
                return React.createElement(ChevronUpSmallIcon_1.ChevronUpSmallIcon, __assign({}, icon));
            case __1.Icons.ChevronUpThin:
                return React.createElement(ChevronUpThinIcon_1.ChevronUpThinIcon, __assign({}, icon));
            case __1.Icons.ClearFilters:
                return React.createElement(ClearFiltersIcon_1.ClearFiltersIcon, __assign({}, icon));
            case __1.Icons.Clock:
                return React.createElement(ClockIcon_1.ClockIcon, __assign({}, icon));
            case __1.Icons.CloseCircle:
                return React.createElement(CloseCircleIcon_1.CloseCircleIcon, __assign({}, icon));
            case __1.Icons.CloseThick:
                return React.createElement(CloseThickIcon_1.CloseThickIcon, __assign({}, icon));
            case __1.Icons.CloseThin:
                return React.createElement(CloseThinIcon_1.CloseThinIcon, __assign({}, icon));
            case __1.Icons.Cog:
                return React.createElement(CogIcon_1.CogIcon, __assign({}, icon));
            case __1.Icons.Column:
                return React.createElement(ColumnIcon_1.ColumnIcon, __assign({}, icon));
            case __1.Icons.Connect:
                return React.createElement(ConnectIcon_1.ConnectIcon, __assign({}, icon));
            case __1.Icons.Designer:
                return React.createElement(DesignerIcon_1.DesignerIcon, __assign({}, icon));
            case __1.Icons.Drag:
                return React.createElement(DragIcon_1.DragIcon, __assign({}, icon));
            case __1.Icons.Edit:
                return React.createElement(EditIcon_1.EditIcon, __assign({}, icon));
            case __1.Icons.EllipsesHorizontal:
                return React.createElement(EllipsesHorizontalIcon_1.EllipsesHorizontalIcon, __assign({}, icon));
            case __1.Icons.EllipsesVertical:
                return React.createElement(EllipsesVerticalIcon_1.EllipsesVerticalIcon, __assign({}, icon));
            case __1.Icons.Export:
                return React.createElement(ExportIcon_1.ExportIcon, __assign({}, icon));
            case __1.Icons.FieldTypeBoolean:
                return React.createElement(FieldTypeBooleanIcon_1.FieldTypeBooleanIcon, __assign({}, icon));
            case __1.Icons.FieldTypeDate:
                return React.createElement(FieldTypeDateIcon_1.FieldTypeDateIcon, __assign({}, icon));
            case __1.Icons.FieldTypeInt:
                return React.createElement(FieldTypeIntIcon_1.FieldTypeIntIcon, __assign({}, icon));
            case __1.Icons.FieldTypeKey:
                return React.createElement(FieldTypeKeyIcon_1.FieldTypeKeyIcon, __assign({}, icon));
            case __1.Icons.FieldTypeString:
                return React.createElement(FieldTypeStringIcon_1.FieldTypeStringIcon, __assign({}, icon));
            case __1.Icons.File:
                return React.createElement(FileIcon_1.FileIcon, __assign({}, icon));
            case __1.Icons.FilterActive:
                return React.createElement(FilterActiveIcon_1.FilterActiveIcon, __assign({}, icon));
            case __1.Icons.Filters:
                return React.createElement(FiltersIcon_1.FiltersIcon, __assign({}, icon));
            case __1.Icons.First:
                return React.createElement(FirstIcon_1.FirstIcon, __assign({}, icon));
            case __1.Icons.Flag:
                return React.createElement(FlagIcon_1.FlagIcon, __assign({}, icon));
            case __1.Icons.Folder:
                return React.createElement(FolderIcon_1.FolderIcon, __assign({}, icon));
            case __1.Icons.FolderOpen:
                return React.createElement(FolderOpenIcon_1.FolderOpenIcon, __assign({}, icon));
            case __1.Icons.FolderOutline:
                return React.createElement(FolderOutlineIcon_1.FolderOutlineIcon, __assign({}, icon));
            case __1.Icons.FolderShared:
                return React.createElement(FolderSharedIcon_1.FolderSharedIcon, __assign({}, icon));
            case __1.Icons.FolderStarred:
                return React.createElement(FolderStarredIcon_1.FolderStarredIcon, __assign({}, icon));
            case __1.Icons.Food:
                return React.createElement(FoodIcon_1.FoodIcon, __assign({}, icon));
            case __1.Icons.Function:
                return React.createElement(FunctionIcon_1.FunctionIcon, __assign({}, icon));
            case __1.Icons.Groups:
                return React.createElement(GroupsIcon_1.GroupsIcon, __assign({}, icon));
            case __1.Icons.Headset:
                return React.createElement(HeadsetIcon_1.HeadsetIcon, __assign({}, icon));
            case __1.Icons.Heart:
                return React.createElement(HeartIcon_1.HeartIcon, __assign({}, icon));
            case __1.Icons.Help:
                return React.createElement(HelpIcon_1.HelpIcon, __assign({}, icon));
            case __1.Icons.Hide:
                return React.createElement(HideIcon_1.HideIcon, __assign({}, icon));
            case __1.Icons.Home:
                return React.createElement(HomeIcon_1.HomeIcon, __assign({}, icon));
            case __1.Icons.ImagePlaceholder:
                return React.createElement(ImagePlaceholderIcon_1.ImagePlaceholderIcon, null);
            case __1.Icons.Import:
                return React.createElement(ImportIcon_1.ImportIcon, __assign({}, icon));
            case __1.Icons.Info:
                return React.createElement(InfoIcon_1.InfoIcon, __assign({}, icon));
            case __1.Icons.Inspection:
                return React.createElement(InspectionIcon_1.InspectionIcon, __assign({}, icon));
            case __1.Icons.Interaction:
                return React.createElement(InteractionIcon_1.InteractionIcon, __assign({}, icon));
            case __1.Icons.Invoicing:
                return React.createElement(InvoicingIcon_1.InvoicingIcon, __assign({}, icon));
            case __1.Icons.Key:
                return React.createElement(KeyIcon_1.KeyIcon, __assign({}, icon));
            case __1.Icons.Last:
                return React.createElement(LastIcon_1.LastIcon, __assign({}, icon));
            case __1.Icons.Link:
                return React.createElement(LinkIcon_1.LinkIcon, __assign({}, icon));
            case __1.Icons.List:
                return React.createElement(ListIcon_1.ListIcon, __assign({}, icon));
            case __1.Icons.Lock:
                return React.createElement(LockIcon_1.LockIcon, __assign({}, icon));
            case __1.Icons.Mail:
                return React.createElement(MailIcon_1.MailIcon, __assign({}, icon));
            case __1.Icons.MapMarker:
                return React.createElement(MapMarkerIcon_1.MapMarkerIcon, __assign({}, icon));
            case __1.Icons.ModuleAdmin:
                return React.createElement(ModuleAdminIcon_1.ModuleAdminIcon, __assign({}, icon));
            case __1.Icons.ModuleCampusLife:
                return React.createElement(ModuleCampusLifeIcon_1.ModuleCampusLifeIcon, __assign({}, icon));
            case __1.Icons.ModuleConduct:
                return React.createElement(ModuleConductIcon_1.ModuleConductIcon, __assign({}, icon));
            case __1.Icons.ModuleConference:
                return React.createElement(ModuleConferenceIcon_1.ModuleConferenceIcon, __assign({}, icon));
            case __1.Icons.ModuleCustom:
                return React.createElement(ModuleCustomIcon_1.ModuleCustomIcon, __assign({}, icon));
            case __1.Icons.ModuleDashboard:
                return React.createElement(ModuleDashboardIcon_1.ModuleDashboardIcon, __assign({}, icon));
            case __1.Icons.ModuleEntries:
                return React.createElement(ModuleEntriesIcon_1.ModuleEntriesIcon, __assign({}, icon));
            case __1.Icons.ModuleFrontDesk:
                return React.createElement(ModuleFrontDeskIcon_1.ModuleFrontDeskIcon, __assign({}, icon));
            case __1.Icons.ModuleKeys:
                return React.createElement(ModuleKeysIcon_1.ModuleKeysIcon, __assign({}, icon));
            case __1.Icons.ModuleMarketplace:
                return React.createElement(ModuleMarketplaceIcon_1.ModuleMarketplaceIcon, __assign({}, icon));
            case __1.Icons.ModulePortal:
                return React.createElement(ModulePortalIcon_1.ModulePortalIcon, __assign({}, icon));
            case __1.Icons.ModuleReports:
                return React.createElement(ModuleReportsIcon_1.ModuleReportsIcon, __assign({}, icon));
            case __1.Icons.ModuleRoomInspections:
                return React.createElement(ModuleRoomInspectionsIcon_1.ModuleRoomInspectionsIcon, __assign({}, icon));
            case __1.Icons.ModuleRoomMatch:
                return React.createElement(ModuleRoomMatchIcon_1.ModuleRoomMatchIcon, __assign({}, icon));
            case __1.Icons.ModuleRooms:
                return React.createElement(ModuleRoomsIcon_1.ModuleRoomsIcon, __assign({}, icon));
            case __1.Icons.ModuleTrustAccount:
                return React.createElement(ModuleTrustAccountIcon_1.ModuleTrustAccountIcon, __assign({}, icon));
            case __1.Icons.MouseHand:
                return React.createElement(MouseHandIcon_1.MouseHandIcon, __assign({}, icon));
            case __1.Icons.MouseHandDrag:
                return React.createElement(MouseHandDragIcon_1.MouseHandDragIcon, __assign({}, icon));
            case __1.Icons.MousePointer:
                return React.createElement(MousePointerIcon_1.MousePointerIcon, __assign({}, icon));
            case __1.Icons.Nav:
                return React.createElement(NavIcon_1.NavIcon, __assign({}, icon));
            case __1.Icons.Note:
                return React.createElement(NoteIcon_1.NoteIcon, __assign({}, icon));
            case __1.Icons.NoteAdd:
                return React.createElement(NoteAddIcon_1.NoteAddIcon, __assign({}, icon));
            case __1.Icons.OpenLink:
                return React.createElement(OpenLinkIcon_1.OpenLinkIcon, __assign({}, icon));
            case __1.Icons.Page:
                return React.createElement(PageIcon_1.PageIcon, __assign({}, icon));
            case __1.Icons.PageLandscape:
                return React.createElement(PageLandscapeIcon_1.PageLandscapeIcon, __assign({}, icon));
            case __1.Icons.PagePortrait:
                return React.createElement(PagePortraitIcon_1.PagePortraitIcon, __assign({}, icon));
            case __1.Icons.Paperclip:
                return React.createElement(PaperClip_1.PaperclipIcon, __assign({}, icon));
            case __1.Icons.Parameter:
                return React.createElement(ParameterIcon_1.ParameterIcon, __assign({}, icon));
            case __1.Icons.ParameterActive:
                return React.createElement(ParameterActiveIcon_1.ParameterActiveIcon, __assign({}, icon));
            case __1.Icons.Parcel:
                return React.createElement(ParcelIcon_1.ParcelIcon, __assign({}, icon));
            case __1.Icons.Paw:
                return React.createElement(PawIcon_1.PawIcon, __assign({}, icon));
            case __1.Icons.Phone:
                return React.createElement(PhoneIcon_1.PhoneIcon, __assign({}, icon));
            case __1.Icons.Picture:
                return React.createElement(PictureIcon_1.PictureIcon, __assign({}, icon));
            case __1.Icons.Plus:
                return React.createElement(PlusIcon_1.PlusIcon, __assign({}, icon));
            case __1.Icons.Portal:
                return React.createElement(PortalIcon_1.PortalIcon, __assign({}, icon));
            case __1.Icons.Preview:
                return React.createElement(PreviewIcon_1.PreviewIcon, __assign({}, icon));
            case __1.Icons.Print:
                return React.createElement(PrintIcon_1.PrintIcon, __assign({}, icon));
            case __1.Icons.Refresh:
                return React.createElement(RefreshIcon_1.RefreshIcon, __assign({}, icon));
            case __1.Icons.Report:
                return React.createElement(ReportIcon_1.ReportIcon, __assign({}, icon));
            case __1.Icons.Reposition:
                return React.createElement(RepositionIcon_1.RepositionIcon, __assign({}, icon));
            case __1.Icons.Resources:
                return React.createElement(ResourcesIcon_1.ResourcesIcon, __assign({}, icon));
            case __1.Icons.Save:
                return React.createElement(SaveIcon_1.SaveIcon, __assign({}, icon));
            case __1.Icons.Search:
                return React.createElement(SearchIcon_1.SearchIcon, __assign({}, icon));
            case __1.Icons.SearchStop:
                return React.createElement(SearchStopIcon_1.SearchStopIcon, __assign({}, icon));
            case __1.Icons.Share:
                return React.createElement(ShareIcon_1.ShareIcon, __assign({}, icon));
            case __1.Icons.ShieldNegative:
                return React.createElement(ShieldNegativeIcon_1.ShieldNegativeIcon, __assign({}, icon));
            case __1.Icons.ShieldPositive:
                return React.createElement(ShieldPositiveIcon_1.ShieldPositiveIcon, __assign({}, icon));
            case __1.Icons.Sort:
                return React.createElement(SortIcon_1.SortIcon, __assign({}, icon));
            case __1.Icons.Source:
                return React.createElement(SourceIcon_1.SourceIcon, __assign({}, icon));
            case __1.Icons.SrIconFull:
                return React.createElement(SrIconFullIcon_1.SrIconFullIcon, __assign({}, icon));
            case __1.Icons.SrIconSimple:
                return React.createElement(SrIconSimpleIcon_1.SrIconSimpleIcon, __assign({}, icon));
            case __1.Icons.Star:
                return React.createElement(StarIcon_1.StarIcon, __assign({}, icon));
            case __1.Icons.StarOutline:
                return React.createElement(StarOutlineIcon_1.StarOutlineIcon, __assign({}, icon));
            case __1.Icons.SubReport:
                return React.createElement(SubReportIcon_1.SubReportIcon, __assign({}, icon));
            case __1.Icons.Tasks:
                return React.createElement(TasksIcon_1.TasksIcon, __assign({}, icon));
            case __1.Icons.TemporarySpace:
                return React.createElement(TemporarySpaceIcon_1.TemporarySpaceIcon, __assign({}, icon));
            case __1.Icons.Tick:
                return React.createElement(TickIcon_1.TickIcon, __assign({}, icon));
            case __1.Icons.TickCircle:
                return React.createElement(TickCircleIcon_1.TickCircleIcon, __assign({}, icon));
            case __1.Icons.TickRounded:
                return React.createElement(TickRoundedIcon_1.TickRoundedIcon, __assign({}, icon));
            case __1.Icons.Tool:
                return React.createElement(ToolIcon_1.ToolIcon, __assign({}, icon));
            case __1.Icons.Trash:
                return React.createElement(TrashIcon_1.TrashIcon, __assign({}, icon));
            case __1.Icons.User:
                return React.createElement(UserIcon_1.UserIcon, __assign({}, icon));
            case __1.Icons.Users:
                return React.createElement(UsersIcon_1.UsersIcon, __assign({}, icon));
            case __1.Icons.Variable:
                return React.createElement(VariableIcon_1.VariableIcon, __assign({}, icon));
            case __1.Icons.View:
                return React.createElement(ViewIcon_1.ViewIcon, __assign({}, icon));
            case __1.Icons.Zoom:
                return React.createElement(ZoomIcon_1.ZoomIcon, __assign({}, icon));
        }
    };
    return Icon;
}(React.PureComponent));
exports.Icon = Icon;
